import React, {useEffect, useState} from 'react';
import {Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import {useLocation, useNavigate} from 'react-router-dom';
import Translate from '../../../src/components/Translate/Translate';
import OrdersList from '../../orders/OrdersList';
import {shortCode} from '@src/helpers/hash/shortCode';
import OrderProductsList from '@views/dashboard/production/OrderProductsList';

export const GET_PARAM_NAME = shortCode('Dashboards:Manager.tabs');

export default function Body() {
    const location = useLocation();
    const navigate = useNavigate();
    const locationTab = decodeURIComponent(
            new URLSearchParams(location.search).get(GET_PARAM_NAME) ?? ''
    );
    const [loadedTabs, setLoadedTabs] = useState<Record<string, true>>({});
    const keys = [
        'Dashboards:Manager.tabs.orders',
        'Dashboards:Manager.tabs.order-products',
    ];

    const activeTab = locationTab && keys.includes(locationTab) ? locationTab : keys[0];

    useEffect(() => {
        setLoadedTabs(map => {
            if (activeTab in map) {
                return map;
            }

            return ({...map, [activeTab]: true});
        });
    }, [activeTab]);

    return <>
        <Nav className="nav-tabs-custom" tabs>
            {keys.map(name => {
                return <NavItem key={`ManagerDashboard-${name}-tab-control`}>
                    <NavLink
                            href={`#${name}`}
                            active={activeTab === name}
                            onClick={e => {
                                e.preventDefault();

                                const search = new URLSearchParams(location.search);
                                search.set(GET_PARAM_NAME, name);

                                navigate({
                                    ...location,
                                    search: search.toString(),
                                }, {replace: true});
                            }}
                    >
                        <Translate message={name}/>
                    </NavLink>
                </NavItem>;
            })}
        </Nav>

        <TabContent activeTab={activeTab} className="py-3">
            {keys.map((name, index) => {
                if (!(name in loadedTabs)) {
                    return null;
                }

                return <TabPane tabId={name} key={`ManagerDashboard-${name}-tab-pane`}>
                    {
                        index === 0 ?
                                <OrdersList controllerName="Orders" isIsolatedComponent/> :
                                <OrderProductsList/>
                    }
                </TabPane>;
            })}
        </TabContent>
    </>;
}
